export default {
    /**
     * 
     * @param {*} ctx :this
     * @param {*} text :内容
     * @param {*} domClass :相对于哪个dom
     * @param {*} width :宽度
     * @param {*} bottom :距离底部多少，百分比
     * @param {*} duration :停留时间，毫秒级
     */
    showToast(ctx, text = '', domClass, bottom = '85%', width = 'auto', duration = 1500) {
        ctx.$toast({
            text: text,
            container: domClass,
            bottom: bottom,
            width: width,
            duration: duration
        });
    },
    /**
     * 
     * @param {*} sKey ：key
     * @param {*} version ：版本号
     * @param {*} callback ：回调
     */
    getLocalStorage(sKey, version='v1.0', callback) {
        let result;
        let projectKey = 'pcclient';
        if (window.__ths_localstorage && window.__ths_localstorage[sKey] && window.__ths_localstorage[sKey].v === version) {
            if (callback) {
                callback(window.__ths_localstorage[sKey].value);
            }
            return window.__ths_localstorage[sKey].value;
        }
        try {
            result = localStorage.getItem(projectKey);
            result = JSON.parse(result);
            window.__ths_localstorage = result;
            if (result && result[sKey] && result[sKey].v === version) {
                if (callback) {
                    callback(result[sKey].value);
                }
                return result[sKey].value;
            }
        } catch (e) {
            console.error(e);
        }
    },
    /**
     * 
     * @param {*} sKey :key
     * @param {*} item :data,[Object,Array,String,Number]
     * @param {*} version :版本号
     */
    setLocalStorage(sKey, item, version = 'v1.0') {
        let projectKey = 'pcclient';
        //为了防止对象被修改
        let value = JSON.parse(JSON.stringify(item));
        if (window.__ths_localstorage) {
            window.__ths_localstorage[sKey] = {
                v: version,
                value: value
            };
        } else {
            window.__ths_localstorage = {};
            window.__ths_localstorage[sKey] = {
                v: version,
                value: value
            };
        }
        try {
            localStorage.setItem(projectKey, JSON.stringify(window.__ths_localstorage));
        } catch (e) {
            console.error(e);
            localStorage.clear();
        }
    },
    /**
     * 
     * @param {*} url 例如：window.location.href
     */
    parseQueryString(url) {
        var result = {};
        if (url.indexOf('?') > -1) {
            var str = url.split('?')[1];
            var temp = str.split('&');  
            for (var i = 0; i < temp.length; i++) {     
                var temp2 = temp[i].split('=');     
                result[temp2[0]] = temp2[1];  
            }  
        }
        return result;
    },

    saveHistory(article){
        if( typeof article != 'object') return false;
    
        let historyList = this.getLocalStorage('historyArticle');
        if( typeof historyList == `string`){
            historyList =  JSON.parse( historyList).filter(ele => ele);
        }else{
            
        }
        // console.log(arr)
        if( historyList){
            let arr = historyList;
            if(!arr.filter( ele => {
                let id1 = ele.seq || ele.id;
                let id2 = article.seq || article.id;
                return id1 == id2
            })[0]){
                arr.unshift( article);
                if(arr.length > 200){
                    arr.pop();
                }
            }
            this.setLocalStorage('historyArticle',arr)
        }else{
            this.setLocalStorage('historyArticle',[article])
        }
    }
};